import {fromJS, List, Map} from 'immutable';

import * as actions from './actions';


export default function reducer(
    state = fromJS({
        elementId: window.uuidv4(),
        errors: {},
    }),
    action,
) {
    if (state.get('elementId') === action.elementId) {
        switch (action.type) {
        case actions.SET_DATA:
            state = state.set('data', fromJS(action.payload));
            break;
        }
    }
    return state;
}
